module.exports = __webpack_public_path__ + "static/media/vicenteFerrer.06ba1561.png";